import { render, staticRenderFns } from "./personal-reply.vue?vue&type=template&id=fc090b42&"
import script from "./personal-reply.vue?vue&type=script&lang=js&"
export * from "./personal-reply.vue?vue&type=script&lang=js&"
import style0 from "./personal-reply.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports